<template>
	<div class="head_wrapper">
		<div class="headList flex_start">
			<div class="logoBox"><img src="../assets/index/logo.png" alt="" /></div>
			<div class="head_nav flex_start" v-if="screenWidth>750">
				<div class="navTabOne" v-for="(item,index) in navList" :key="index" @click="routerPush(index)">{{item}}</div>
			</div>
			<div class="loginBtn" slot="reference" v-show="screenWidth>750" @click.stop="showLoginBox">登录</div>
		</div>
		<div style="height: 49px;" v-if="screenWidth<=750"></div>
	</div>
</template>

<script>
	import Sidentify from '../components/graphicVerifi.vue';
	export default {
		components: {
			's-Identify': Sidentify
		},
		props: {
			screenWidth: {
				type: Number,
				default: 1920
			}
		},
		watch: {
			
		},
		data() {
			return {
				navList: ['首页', '产品服务', '产品形式', '合作伙伴'],
				formData: {},
				loginFormData: {},
				registerFormData: {},
				forgetPwdFormData: {},
				code: '',
				identifyCode: '1234',
				// 验证码规则
				identifyCodes: '1234567890',
				loginCheck: 1,
			}
		},
		computed: {

		},
		created() {

		},
		methods: {
			// 切换验证码
			refreshCode() {
				this.identifyCode = ''
				this.makeCode(this.identifyCodes, 4)
			},
			// 生成随机验证码
			makeCode(o, l) {
				for (let i = 0; i < l; i++) {
					this.identifyCode += this.identifyCodes[
						Math.floor(Math.random() * (this.identifyCodes.length - 0) + 0)
					]
				}
			},
			routerPush(index) {
				this.$emit('navClick', index)
			},
			showLoginBox() {
				// this.loginDialogVisible = true;
				this.$emit('openLoginBox');
			},
		},
		mounted() {
			// this.refreshCode()
		},
	}
</script>

<style scoped>
	.head_wrapper {
		width: 100%;
		/* position: fixed; */
		top: 0;
		left: 0;
	}

	.headList {
		height: 96px;
		max-width: 1200px;
		margin: 0 auto;
		align-items: center;
	}

	.logoBox {
		width: 176px;
		height: 54px;
	}

	.head_nav {}

	.navTabOne {
		color: #333333;
		font-size: 18px;
		cursor: pointer;
		margin-left: 48px;
		font-weight: 500;
	}

	.navTabOne:hover {
		/* color: #ebebeb;
		background: #373435; */
	}

	.loginBtn {
		margin-left: auto;
		width: 81px;
		height: 32px;
		background: #2173FF;
		border-radius: 14px 14px 14px 14px;
		font-size: 14px;
		color: #ffffff;
		text-align: center;
		line-height: 32px;
		cursor: pointer;
		border-radius: 34px;
	}

	.idCode {
		width: 100%;
	}

	.codeInput {
		/* width: 238px; */
		/* margin-bottom: 25px; */
		width: 60%;
	}


	@media screen and (max-width: 750px) {
		.headList {
			width: 100%;
			padding: 0 2px;
			box-sizing: border-box;
			height: 48px;
			background: #ffffff;
			border-bottom: 1px solid #F6F6F7;
			position: fixed;
			left: 0;
			top: 0;
			z-index: 999;
			box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.03);
		}

		.logoBox {
			width: 133px;
			height: 40px;
		}

		.loginBtn {
			width: 64px;
			height: 25px;
			line-height: 25px;
			font-size: 12px;
			margin-right: 14px;
		}
	}

	img {
		width: 100%;
		height: 100%;
	}
</style>